import { IExplorableItemTypeInfo, IRecommendationItem } from '../../spacesPlatform/models/resourceInfoParts';

// Client side interface for viz recommendation
export type IViewRecommendationInfo = IExplorableItemTypeInfo<'recommendedView'> & IRecommendationItem;

export const PopularExplanation = 'popular';
export const SimiliarUsersExplanation =  'similar_users';
